var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maincontainer header"},[_c('a',{staticClass:"logo",staticStyle:{"cursor":"pointer"},on:{"click":_vm.toLogin}}),_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.changeLang(_vm.targetLanguage)}}},[_vm._v(_vm._s(_vm.targetLanguage.displayName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }